import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;
const NO_REFRESH = ['/auth/refresh', '/auth/login', '/auth/logout', '/auth/register', '/auth/2fa'];

let refreshing = null;

function refreshSession() {
  if (!refreshing) {
    refreshing = axios.post(`${API_BASE}/api/auth/refresh`, {}, { withCredentials: true })
      .finally(() => { refreshing = null; });
  }
  return refreshing;
}

// On 401, mint a fresh access token from the refresh cookie once, then retry the request.
export function attachAutoRefresh(client) {
  client.interceptors.response.use(
    (res) => res,
    async (error) => {
      const original = error.config;
      const url = original?.url || '';
      if (error.response?.status !== 401 || !original || original._retried ||
          NO_REFRESH.some((p) => url.includes(p))) {
        throw error;
      }
      original._retried = true;
      try {
        await refreshSession();
      } catch {
        // refresh cookie gone/expired: send them to sign in, keep the original 401
        if (!window.location.pathname.startsWith('/login')) window.location.assign('/login');
        throw error;
      }
      return client(original);
    }
  );
  return client;
}

const ax = attachAutoRefresh(axios.create({ withCredentials: true }));
export default ax;
